import { Component, Input, NgModule, OnInit, ViewChild } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { ApplicationRoles, ApplicationRolesEnumDescriptionService } from '../users/user-roles';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { UserService } from 'src/app/services/user.service';
import { AccessControl, AccessControlDefaultValues } from '../users/access-control';
import { CheckPageAccess } from '../authorize/check-page-access';
import { LoginService } from 'src/app/services/login.service';
import { TranslationService } from 'src/app/services/translation.service';
import { LanguageService } from 'src/app/services/language.service';
import { ApplicationLanguages } from '../language/language';
import { faChevronDown, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { faUser } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AuthorizeComponent } from '../authorize/authorize.component';
import { NgModel } from '@angular/forms';
import { filter } from 'rxjs';
import { AdminProgramMode } from '../authorize/admin-program-mode';
import { RoleOnboardingService } from 'src/app/services/role-onboarding.service';

@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.scss'],
  standalone: true,
  imports: [
    BrowserModule,
    FormsModule,
    RouterModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatMenuModule,
    MatFormFieldModule,
    MatSelectModule,
    FontAwesomeModule
  ],
})
export class TopnavComponent implements OnInit {

  @Input() llttfPage = false;
  @Input() pageName: CheckPageAccess = CheckPageAccess.DASHBOARDADMIN;

  token: string = '';
  showUserInfo: boolean = false;
  username: string = '';
  userRole: string = '';
  userlogo: boolean = true;
  applicationVersion: string = '';
  showApplicationVersion: boolean = false;
  profileVisible: boolean = true;
  contentClass: string = 'collapse navbar-collapse';
  isClicked = true;
  dashboardLink = '';
  count = 0;
  accessControl: AccessControl = AccessControlDefaultValues();
  showProgramToggle: boolean = false;
  isParticipant = false;
  courseMenuName: string = 'Courses';
  BBCoachedParticipantRole = ApplicationRoles.BB_CoachedParticipant;
  BBSelfGuidedParticipantRole = ApplicationRoles.BB_SelfGuidedParticipant;
  LLTTFCoachedParticipantRole = ApplicationRoles.LLTTF_CoachedParticipant;
  applicationLanguages: any[] = [];
  translation: any;
  profileLabel: string = 'Profile';
  logoutLabel: string = 'Logout';
  dashboardLabel: string = 'Dashboard';
  courseLabel: string = 'Courses';
  sessionLabel:string = 'Sessions';
  bbCoachedProgramLabel: string = 'BounceBack Coached';
  bbSelfGuidedProgramLabel: string = 'BounceBack Self Guided';
  currentLanguage: string = 'English';
  faProfile: IconDefinition = faUser;
  faChevronDown: IconDefinition = faChevronDown;
  activeLink: string = '';
  mobileMenuOpen = false;
  isLlttfInvitationRoute = false;
  adminProgramMode: AdminProgramMode = 'bb';
  hasPendingOnboarding = false;
  private readonly publicRoutes = ['/aboutus', '/contact-us', '/privacy-policy'];

  constructor (private route: Router,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private _userservice: UserService,
                private _authservice: AuthService,
                private _loginservice: LoginService,
                private translationService: TranslationService,
                private languageservice: LanguageService,
                private roleOnboardingService: RoleOnboardingService) {
    this.initializeFromCache();
    this.setActiveLink(this.router.url);
    this.setAdminLogo();
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        const url = this.router.url;
        this.setActiveLink(url);
        this.setAdminLogo();
        this.closeMenu();
      });
  }

  private initializeFromCache(): void {
    this.accessControl = this._authservice.getAccessControl();
    const userData = this._authservice.getUserLoginData();
    if (userData.token) {
      this.username = userData.agentName;
      this.isParticipant = userData.isParticipant;
      this.setAdminLogo();
    }
  }

  setActiveLink(url: string) {
    this.isLlttfInvitationRoute = this.isLlttfInvitationUrl(url);

    // participant dashboard
    if (url.includes('participants/plans')) {
      this.activeLink = 'participant-dashboard';
    }
    // participant course
    else if (url.includes('participants/courses')) {
      this.activeLink = 'participant-course';
    }
    // user management
    else if (url.includes('user-list')
        || url.includes('create-user')
        || url.includes('view-user')
        || url.includes('edit-user')) {
      this.activeLink = 'user-management';
    }
    //invitation-management
    else if (url.includes('access-denied-invitation')
        || url.includes('bb-invite-list')
        || url.includes('create-bb-invitation')
        || url.includes('view-bb-invitation')
        || url.includes('edit-bb-invitation')
        || url.includes('llttf-invite-list')
        || url.includes('create-llttf-invitation')
        || url.includes('view-llttf-invitation')
        || url.includes('edit-llttf-invitation')) {
      this.activeLink = 'invitation-management';
    }
    // Course Management
    else if (url.includes('tags-list')
        || url.includes('create-tag')
        || url.includes('view-tag')
        || url.includes('edit-tag')
        || url.includes('material-list')
        || url.includes('add-material')
        || url.includes('edit-material')
        || url.includes('view-material')
        || url.includes('course-list')
        || url.includes('add-course')
        || url.includes('edit-course')
        || url.includes('view-course')
        || url.includes('bulk-import')) {
      this.activeLink = 'course-management';
    }
    // org Management
    else if (url.includes('add-org')
        || url.includes('view-org')
        || url.includes('edit-org')
        || url.includes('org-list')) {
      this.activeLink = 'org-management';
    }
    // Reporting
    else if (url.includes('reports/')) {
      this.activeLink = 'reporting';
    }
    else if (url.includes('role-training')) {
      this.activeLink = 'role-training';
    }
    else {
      this.activeLink = '';
    }

    this.setAdminLogo();
  }

  get hasDualProgramAccess(): boolean {
    return this._authservice.hasDualProgramAccess();
  }

  get isBbMode(): boolean {
    return this._authservice.getEffectiveProgramMode() === 'bb';
  }

  get isLlttfMode(): boolean {
    return this._authservice.getEffectiveProgramMode() === 'llttf';
  }

  /** True when the current admin UI is LLTTF-branded / LLTTF-scoped. */
  get isLlttfContext(): boolean {
    return this.isLlttfMode || this.llttfPage;
  }

  get showBbInvitationsNav(): boolean {
    return !!this.accessControl.bbInvitaitons && this.isBbMode && !this.lockNavForOnboarding;
  }

  get showLlttfInvitationsNav(): boolean {
    return !!this.accessControl.llttfInvitations && this.isLlttfMode && !this.lockNavForOnboarding;
  }

  get showCourseManagementNav(): boolean {
    return !!this.accessControl.courseManagement && !this.lockNavForOnboarding;
  }

  get courseManagementNavLabel(): string {
    return this.isLlttfContext ? 'Sessions' : 'Courses';
  }

  get showOrgManagementNav(): boolean {
    return !!this.accessControl.orgManagement && this.isLlttfMode && !this.lockNavForOnboarding;
  }

  get showReportingNav(): boolean {
    return !!this.accessControl.reporting && this.isBbMode && !this.lockNavForOnboarding;
  }

  get showRoleTrainingNav(): boolean {
    return !!this.accessControl.roleOnboardingManagement;
  }

  get showMyTrainingNav(): boolean {
    return !this.isParticipant && !this.accessControl.roleOnboardingManagement && !this.lockNavForOnboarding;
  }

  get lockNavForOnboarding(): boolean {
    return this.hasPendingOnboarding;
  }

  get bbInvitationsNavLabel(): string {
    return this.hasDualProgramAccess ? 'BB Invitations' : 'Invitations';
  }

  get llttfInvitationsNavLabel(): string {
    return 'Cohorts';
  }

  private isLlttfInvitationUrl(url: string): boolean {
    return url.includes('llttf-invite-list')
      || url.includes('create-llttf-invitation')
      || url.includes('view-llttf-invitation')
      || url.includes('edit-llttf-invitation')
      || url.includes('accessllttfcohortlink')
      || url.includes('llttf-email-verification')
      || url.includes('llttf-check-eligibility')
      || url.includes('registerllttfcoachedparticipant');
  }

  async ngOnInit(): Promise<void> {
    const isPublicRoute = this.isPublicRoute();

    if (!isPublicRoute && !this._authservice.checkTokenExpiry()) {
      this.router.navigateByUrl('/bb-login');
    }

    await this.languageservice.getApplicationLanguages().subscribe({
      next: (data) => {
        this.applicationLanguages = data;
      }
    });

    await this.translationService.getTranslation().subscribe((translations: any) => {
      this.translation = translations;
      this.profileLabel = translations['profile']
      this.logoutLabel = translations['logout']
      this.dashboardLabel = translations['dashboard']
      this.courseLabel = translations['courseMenuLabel']
      this.sessionLabel = translations['sessionMenuLabel']
      this.bbCoachedProgramLabel = translations['bbCoachedProgramText']
      this.bbSelfGuidedProgramLabel = translations['bbSelfGuidedProgramText']
    });

    if (!isPublicRoute || this._authservice.checkTokenExpiry()) {
      await this._userservice.getAccessControlForUser().subscribe({
        next: (data) => {
          this.accessControl = data;
          this._authservice.setAccessControl(this.accessControl);
          this.username = this._authservice.getUserLoginData().agentName;
          this.isParticipant = this._authservice.getUserLoginData().isParticipant
          this.courseMenuName = this._authservice.getAccessControl().participantLastActiveRole == ApplicationRoles.LLTTF_CoachedParticipant ? this.sessionLabel: this.courseLabel
          this.setAdminLogo();
          this.checkPendingOnboarding();
        },
      });
    }

    this.currentLanguage = this.languageservice.getCurrentActiveLanguageName();
  }

  private checkPendingOnboarding(): void {
    if (this.isPublicRoute() || !this._authservice.checkTokenExpiry()) {
      if (!this.isPublicRoute()) {
        this.checkPageAccess();
      }
      return;
    }

    this.roleOnboardingService.getPending().subscribe({
      next: (pending) => {
        this.hasPendingOnboarding = (pending ?? []).some(c => c.isMandatory);
        if (this.hasPendingOnboarding && !this.isOnboardingAllowedRoute()) {
          this.router.navigateByUrl('/onboarding-training');
          return;
        }
        if (!this.isPublicRoute()) {
          this.checkPageAccess();
        }
      },
      error: () => {
        if (!this.isPublicRoute()) {
          this.checkPageAccess();
        }
      }
    });
  }

  private isOnboardingAllowedRoute(): boolean {
    const url = this.router.url.split('?')[0];
    if (url === '/onboarding-training' || url === '/my-training' || url === '/bb-login' || url === '/404') {
      return true;
    }
    if (this.publicRoutes.includes(url)) {
      return true;
    }
    if (this.accessControl.roleOnboardingManagement
      && (url === '/role-training-list'
        || url.startsWith('/create-role-training')
        || url.startsWith('/edit-role-training')
        || url.startsWith('/view-role-training'))) {
      return true;
    }
    return false;
  }

  private isPublicRoute(): boolean {
    const url = this.router.url.split('?')[0];
    return this.publicRoutes.includes(url);
  }

  navigate(url: string) {
    this.route.navigateByUrl(url);
  }

  checkPageAccess(): void {
    let flag = false;
    const pageName = this.resolvePageName();

    switch (pageName) {
      case CheckPageAccess.DASHBOARDADMIN:
        flag = !this.isParticipant;
        break;
      case CheckPageAccess.DASHBOARDPARTICIPANT:
        flag = this.isParticipant;
        break;
      case CheckPageAccess.USERMANAGEMENT:
        flag = this.accessControl.userManagement;
        break;
      case CheckPageAccess.BBINVITATIONS:
        flag = this.accessControl.bbInvitaitons;
        break;
      case CheckPageAccess.LLTTFINVITATIONS:
        flag = this.accessControl.llttfInvitations;
        break;
      case CheckPageAccess.TAGS:
        flag = this.accessControl.tags;
        break;
      case CheckPageAccess.MATERIALS:
        flag = this.accessControl.materials;
        break;
      case CheckPageAccess.COURSES:
        flag = this.accessControl.courses;
        break;
      case CheckPageAccess.ORGMANAGEMENT:
        flag = this.accessControl.orgManagement;
        break;
      case CheckPageAccess.REPORTING:
        flag = this.accessControl.reporting;
        break;
      case CheckPageAccess.ADDBBINVITATION:
        flag = this.accessControl.addBBInvitation;
        break;
      case CheckPageAccess.EDITBBINVITATION:
        flag = this.accessControl.editBBInvitation;
        break;
      case CheckPageAccess.ADDLLTTFINVITATION:
        flag = this.accessControl.addLLTTFInvitation;
        break;
      case CheckPageAccess.EDITLLTTFINVITATION:
        flag = this.accessControl.editLLTTFInvitation;
        break;
      case CheckPageAccess.ADDUSER:
        flag = this.accessControl.addUser;
        break;
      case CheckPageAccess.EDITUSER:
        flag = this.accessControl.editUser;
        break;
      case CheckPageAccess.ADDTAG:
        flag = this.accessControl.addTags;
        break;
      case CheckPageAccess.EDITTAG:
        flag = this.accessControl.editTags;
        break;
      case CheckPageAccess.ADDMATERIAL:
        flag = this.accessControl.addMaterials;
        break;
      case CheckPageAccess.EDITMATERIAL:
        flag = this.accessControl.editMaterials;
        break;
      case CheckPageAccess.ADDCOURSE:
        flag = this.accessControl.addCourse;
        break;
      case CheckPageAccess.EDITCOURSE:
        flag = this.accessControl.editCourse;
        break;
      case CheckPageAccess.EMAILQUEUE:
        flag = this.accessControl.emailQueue;
        break;
      case CheckPageAccess.ROLEONBOARDING:
      case CheckPageAccess.ADDROLEONBOARDING:
      case CheckPageAccess.EDITROLEONBOARDING:
        flag = this.accessControl.roleOnboardingManagement;
        break;
      case CheckPageAccess.ONBOARDINGTRAINING:
        flag = true;
        break;
      case CheckPageAccess.MYTRAINING:
        flag = !this.isParticipant && !this.accessControl.roleOnboardingManagement;
        break;
      case CheckPageAccess.BULKIMPORT:
        flag = this.accessControl.canBulkImport;
        break;
    }

    if (!flag) {
      this.navigate('/404');
    }
  }

  private resolvePageName(): CheckPageAccess {
    if (this.pageName === CheckPageAccess.DASHBOARDADMIN) {
      return this.isParticipant
        ? CheckPageAccess.DASHBOARDPARTICIPANT
        : CheckPageAccess.DASHBOARDADMIN;
    }

    return this.pageName;
  }

  logout(): void {
    this._loginservice.logoutUser().subscribe({
      next: () => {
        window.location.href='/bb-login'
        //this.route.navigateByUrl('/bb-login');
      }
    });
  }

  changePassword(): void {
    if (this.isParticipant) {
      this.route.navigate(['participants/profile']);
    } else {
      this.route.navigate(['admin-profile']);
    }
  }

  changeToggle() {
    if (this.isClicked) {
      this.contentClass = 'collapse navbar-collapse show responsive-panel';
      this.isClicked = false;
    } else {
      this.contentClass = 'collapse navbar-collapse';
      this.isClicked = true;
    }
  }

  toggleMenu(): void {
    this.mobileMenuOpen = !this.mobileMenuOpen;
    document.body.style.overflow = this.mobileMenuOpen ? 'hidden' : '';
  }

  closeMenu(): void {
    if (!this.mobileMenuOpen) {
      return;
    }
    this.mobileMenuOpen = false;
    document.body.style.overflow = '';
  }

  setParticipantLastActiveRole(lastActiveRole:ApplicationRoles)
  {
    this._userservice.setParticipantLastActiveRole(lastActiveRole).subscribe({
      next: (data) => {
        this.accessControl.participantLastActiveRole = lastActiveRole;
        this._authservice.setAccessControl(this.accessControl);
        location.reload();
      }
    });
  }

 setLanguage(langid: number){
  this._userservice.setUserLanguage(langid).subscribe({
    next: (data) => {
      this.languageservice.setCurrentLang(langid.toString());
      location.reload();
    }
  });
 }

 isActiveLanguage(langId: number): boolean {
  return this.languageservice.getCurretnLang() === langId;
 }

 getLanguageButtonLabel(lang: { id: number; description?: string }): string {
  if (lang.id === ApplicationLanguages.FRENCH) {
    return 'FR';
  }
  return 'EN';
 }

  setAdminLogo() {
    if (this.isParticipant) {
      return;
    }

    this.adminProgramMode = this._authservice.getAdminProgramMode();
    // Program switch is DevAdmin-only (canEditEmail is the DevAdmin-only access flag).
    this.showProgramToggle = !!this.accessControl.canEditEmail;

    if (this.hasDualProgramAccess) {
      this.llttfPage = this.adminProgramMode === 'llttf';
      return;
    }

    this.llttfPage = !this._authservice.getUserLoginData().showBBLogo;
  }

  onProgramModeChange(mode: AdminProgramMode) {
    if (!this.accessControl.canEditEmail) {
      return;
    }

    if (!mode || mode === this.adminProgramMode) {
      return;
    }

    this._authservice.setAdminProgramMode(mode);
    this.adminProgramMode = mode;
    this.llttfPage = mode === 'llttf';

    const target = mode === 'llttf' ? '/llttf-invite-list' : '/bb-invite-list';
    this.route.navigateByUrl(target).then(() => {
      location.reload();
    });
  }

  get homeDashboardPath(): string {
    if (this.isParticipant) {
      return '/dashboard-participant';
    }

    return '/dashboard-bb';
  }

}

